import Lenis from 'lenis';
import type { LenisOptions } from 'lenis';
import type { LenisLike } from '~/types/cms';

export const useLenis = (state: boolean) => {
    const { $gsap: gsap, $ScrollTrigger: ScrollTrigger } = useNuxtApp();

    const SCROLL_THRESHOLD = 50;
    const SCROLL_THRESHOLD_TOP = 100;

    const dataLenis = useLenisData();
    const scrollState = useScrollState();

    if (dataLenis.value && state) {
        dataLenis.value = null;
        ScrollTrigger.getAll().forEach(tr => tr.kill());
    }

    if (state) {
        // init Lenis
        const lenis = new Lenis(<LenisOptions>{
            duration: 0.9,
            easing: t => Math.min(1, 1.001 - Math.pow(2, -11 * t)),
            smoothWheel: true,
            orientation: 'vertical',
            gestureOrientation: 'vertical'
        });

        document.body.dataset.scrollDirection = 'init';
        document.body.dataset.scrolled = 'false';

        lenis.on('scroll', ScrollTrigger.update);
        gsap.ticker.add(time => lenis.raf(time * 1000));
        gsap.ticker.lagSmoothing(0);
        lenis.scrollTo(0, { immediate: true, force: true, duration: 0 });

        lenis.on('scroll', e => {
            const targetScroll = e.targetScroll;

            if (Math.abs(scrollState.value - targetScroll) >= SCROLL_THRESHOLD) {
                document.body.dataset.scrollDirection = targetScroll > scrollState.value ? 'down' : 'up';
                document.body.dataset.scrolled = targetScroll >= SCROLL_THRESHOLD_TOP ? 'true' : 'false';
                scrollState.value = targetScroll;
            }
        });

        dataLenis.value = lenis as unknown as LenisLike;
    }
};
